// Registered before the details route: `create` would otherwise be read as a task id.
export default {
  path: 'winter-service/v2/tasks/create',
  name: 'WinterService2TaskCreate',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/TaskCreate.vue')
}
